export function initFlashToasts() {
  function removeToast(el){
    el.style.transition = "opacity .35s ease, transform .35s ease";
    el.style.opacity = "0";
    el.style.transform = "translateX(12px)";
    setTimeout(()=> el.remove(), 350);
  }

  document.querySelectorAll('#flash-messages div').forEach(el => {
    if (el.dataset.flashInitialized) return;
    el.dataset.flashInitialized = "true";

    const close = el.querySelector('.flash-close');
    if (close) close.addEventListener('click', () => removeToast(el));

    const timeout = parseInt(el.dataset.timeout || "3000", 10);
    if (timeout > 0) setTimeout(() => {
      if (document.body.contains(el)) removeToast(el);
    }, timeout);
  });
}

document.addEventListener('DOMContentLoaded', initFlashToasts);
document.addEventListener('turbo:load', initFlashToasts);
